export enum LocalStorageKeys {
  Locale = 'locale',
  Token = 'token',
  Hash = 'hash',
}
